import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdKind } from '@/api/types/common.types';
import { AdService } from '@/api/types/services.types';
import { AdBundle } from '@/api/types/categories.types';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';
import { BundleLabel } from '@/components/Ad/Promotions/BundleLabel';
import {
  hasOneSale,
  isNovelty,
} from '@/components/Ad/Promotions/Promotions.helpers';
import { ServiceLabel } from '@/components/Ad/Promotions/ServiceLabel';
import * as PromotionS from '@/components/Ad/Promotions/Promotion.styles';
import * as S from '@/components/Ad/Promotions/PromotionDrawer.styles';
import {
  buildServiceIdForBundle,
  buildServiceIdForService,
} from '@/components/Ad/Promotions/PromotionDrawer.helpers';
import { formatNumber } from '@/utils/helpers';
import { useCurrentCategoryDetails } from '@/hooks/useCurrentCategory/useCurrentCategoryDetails';

type Props = {
  services: Record<AdKind, AdService[] | undefined>;
  type: AdKind | null;
  bundle: AdBundle | null;
  walletDiscount: number;
  isWallet: boolean;
  isBundles: boolean;
  setBundle: React.Dispatch<React.SetStateAction<AdBundle | null>>;
  setService: React.Dispatch<React.SetStateAction<AdService | null>>;
  service: AdService | null;
};
export function ServiceCheckboxes({
  services,
  type,
  bundle,
  walletDiscount,
  isWallet,
  isBundles,
  setBundle,
  setService,
  service,
}: Props) {
  const { t } = useTranslation();

  const { categoryDetails } = useCurrentCategoryDetails();

  if (!type && isBundles && categoryDetails?.bundles.length) {
    return categoryDetails.bundles.map(el => {
      return (
        <Checkbox
          dataTestId={buildServiceIdForBundle(bundle)}
          key={el.id}
          onChangeHook={() => setBundle(el)}
          value={el.id === bundle?.id}
          label={<BundleLabel bundle={el} />}
          labelPosition="right"
          appearance="radio"
          size="md"
          color="secondary"
        />
      );
    });
  }

  if (!services || !type) return null;
  const currentServices = services[type];
  return currentServices?.map(el => {
    const withSale = hasOneSale(el);
    const prevPriceFormatted = `${formatNumber(el.previousPrice, 2)} AZN`;

    return (
      <Checkbox
        dataTestId={buildServiceIdForService(el, type)}
        key={el.period}
        onChangeHook={() => setService(el)}
        value={el.period === service?.period}
        label={
          <ServiceLabel
            currentService={el}
            isPeriod={type === AdKind.Bumped}
            walletDiscount={walletDiscount}
            isWallet={isWallet}
            withSale={withSale}
          />
        }
        labelPosition="right"
        appearance="radio"
        size="md"
        color="secondary"
        hasSmallGap
        {...(withSale && {
          customContent: (
            <PromotionS.PrevPrice>{prevPriceFormatted}</PromotionS.PrevPrice>
          ),
        })}
        {...(isNovelty(el) && {
          customContent: <S.NoveltyLabel>{t('common.novelty')}</S.NoveltyLabel>,
        })}
      />
    );
  });
}
